import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	PagerDutyIncidentsUpdateRequest,
	PagerDutyIncidentsAckUpdateRequest,
	PagerDutyIncidentsTableRequest,
	DownloadPagerDutyIncidentsRequest,
	DownloadCurrentWeekIncidentsRequest,
	GetDropdownsRequest,
	CreateIncidentRequest,
	EditIncidentRequest,
	DeleteIncidentRequest,
	GetIncidentRequest
} from '../requests/PagerDutyIncidentsRequests.js';

export const GET_PAGERDUTY_INCIDENTS_UPDATE = 'GET_PAGERDUTY_INCIDENTS_UPDATE';
export const GET_PAGERDUTY_INCIDENTS_ACK_UPDATE = 'GET_PAGERDUTY_INCIDENTS_ACK_UPDATE';
export const GET_PAGERDUTY_INCIDENTS_TABLE = 'GET_PAGERDUTY_INCIDENTS_TABLE';
export const TOGGLE_INCIDENT_TRACKER_DIALOG = 'TOGGLE_INCIDENT_TRACKER_DIALOG';
export const TOGGLE_DELETE_INCIDENT_DIALOG = 'TOGGLE_DELETE_INCIDENT_DIALOG';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_INCIDENT = 'GET_INCIDENT';
export const GET_DROPDOWNS = 'GET_DROPDOWNS';
export const GET_ALL_DROPDOWNS = 'GET_ALL_DROPDOWNS';

const onGetPagerDutyIncidentsUpdate = (value) => ({
	type: GET_PAGERDUTY_INCIDENTS_UPDATE,
	incidentsLastUpdate: value
});

export const GetPagerDutyIncidentsUpdate = () => async (dispatch) => {
	await PagerDutyIncidentsUpdateRequest().then(response => {
		dispatch(onGetPagerDutyIncidentsUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetPagerDutyIncidentsAckUpdate = (value) => ({
	type: GET_PAGERDUTY_INCIDENTS_ACK_UPDATE,
	incidentsAckLastUpdate: value
});

const onToggleIncidentTrackerDialog = (visible, incidentId, incidentClosed) => ({
	type: TOGGLE_INCIDENT_TRACKER_DIALOG,
	visible,
	incidentId,
	incidentClosed
});

const onToggleDeleteIncidentDialog = (visible, incidentId) => ({
	type: TOGGLE_DELETE_INCIDENT_DIALOG,
	visible,
	incidentId
});

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetPagerDutyIncidentsTable = (value) => ({
	type: GET_PAGERDUTY_INCIDENTS_TABLE,
	incidentsTableData: value
});

const onGetIncident = (value) => ({
	type: GET_INCIDENT,
	incident: value
});

const onGetDropdowns = (value) => ({
	type: GET_DROPDOWNS,
	dropdowns: value
});

export const GetDropdowns = () => async (dispatch) => {
	await GetDropdownsRequest().then(response => {
		dispatch(onGetDropdowns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetIncident = (incidentId) => async (dispatch) => {
	await GetIncidentRequest(incidentId).then(response => {
		dispatch(onGetIncident(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetPagerDutyIncidentsTable = () => async (dispatch) => {
	await PagerDutyIncidentsTableRequest().then(response => {
		dispatch(onGetPagerDutyIncidentsTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const CreateIncident = (incidentForm) => async (dispatch) => {
	const form = {
		...incidentForm,
		createdOn: new Date(incidentForm.createdOn).toISOString(),
	};
	await CreateIncidentRequest(form).then(response => {
		dispatch(enqueueSnackbar({ message: 'Incident successfully created.', options: { variant: 'success' } }));
		dispatch(GetPagerDutyIncidentsTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditIncident = (incidentForm) => async (dispatch) => {
	await EditIncidentRequest(incidentForm).then(response => {
		dispatch(enqueueSnackbar({ message: 'Incident successfully edited.', options: { variant: 'success' } }));
		dispatch(GetPagerDutyIncidentsTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeleteIncident = (id) => async (dispatch) => {
	await DeleteIncidentRequest(id).then(response => {
		dispatch(enqueueSnackbar({ message: 'Incident successfully deleted.', options: { variant: 'success' } }));
		dispatch(GetPagerDutyIncidentsTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ToggleIncidentTrackerDialog = (visible, incidentId, incidentClosed = false) => (dispatch) => {
	dispatch(onToggleIncidentTrackerDialog(visible, incidentId, incidentClosed));
};

export const ToggleDeleteIncidentDialog = (visible, incidentId) => (dispatch) => {
	dispatch(onToggleDeleteIncidentDialog(visible, incidentId));
};

export const GetPagerDutyIncidentsAckUpdate = () => async (dispatch) => {
	await PagerDutyIncidentsAckUpdateRequest().then(response => {
		dispatch(onGetPagerDutyIncidentsAckUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DownloadPagerDutyIncidents = () => async (dispatch) => {
	await DownloadPagerDutyIncidentsRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DownloadCurrentWeekIncidents = () => async (dispatch) => {
	await DownloadCurrentWeekIncidentsRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
